function MenuRBKO() {
  return (
    <div className="bg-white">
      <div className="container ">RBKO MENU</div>;
    </div>
  );
}

export default MenuRBKO;
